import getSymbolFromCurrency from 'currency-symbol-map';
import { getCurrency } from 'locale-currency';
import { getLocaleCode } from '../../locale';

/**
 * @param locale { string } A code for the locale format. (either BCP-47 or ISO 639-1)
 * @return { string } A locale code. (ISO 639-1 w/ optional two character region subtag) ex) en, en-US, en-CA, fr-CA, fr
 */
export const getCurrencyCode = (locale: string): string => {
  if (getLocaleCode(locale) == 'cs') {
    return getCurrency('cz');
  }
  // 'sv' is the ISO 639-1 language code for Swedish, but locale-currency reads a bare
  // 'sv' as the El Salvador region and returns SVC. Map to the Swedish region for SEK.
  if (getLocaleCode(locale) == 'sv') {
    return getCurrency('se');
  }
  return getCurrency(getLocaleCode(locale) || 'en');
};

/**
 * @param code {string } Three character currency code. (ISO 4217) ex) USD, CAD, AUS
 * @return {string} The currency symbol for the given currency code.
 */
export const getCurrencySymbol = (code: string): string | undefined => {
  return getSymbolFromCurrency(code);
};
